import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

export var form =
{
	model: 'tutorial',

	form_title: 'Tutoriel',

	fields:
	{
		'title':
		{
			label: 'Titre',
			front_indicator: true
		},

		thumbnail:
		{
			front_indicator: true,
			label: 'Image (miniature)',
			type: 'image',
			multiple: false
		},

		date:
		{
			type :'date',
			label: 'Date',
			front_indicator: true
		},

		type:
		{
			type :'select',
			label: 'Visibilité',

			options:
			[
				{
					value: 'classic',
					label: 'Visible par membres et élus'
				},
				{
					value: 'EC',
					label: 'Visible si connecté en tant qu\'admin'
				}
			]
		},

		'youtube':
		{
			label: 'Vidéos YouTube',
			youtube: true,
			repeatable: false,
			front_indicator: true
		}
	},

	'create_label': 'Créer ce tutoriel',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>

				<p>
					Êtes vous sûr de vouloir supprimer ce tutoriel&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['tutorial[title]'] }

					</div>

				</div>

			</span>
		);

		return output;
	},

	get__createdMessage: function (tutorial)
	{
		var output =
		(
			<div className="c-message c-message--green">

				<div className="c-message__content">
					Le nouveau tutoriel <strong> { tutorial.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-des-CE/tutoriels/' + tutorial.id }>
						Voir le tutoriel
					</Link>
				</div>

			</div>
		);

		return output;
	}
};

export var list =
{
	model: 'tutorial',
	title: 'Liste des tutoriels',

	link: '/gestion-des-CE/tutoriels',

	creation_label: 'Nouveau tutoriel',
	creation_link : '/gestion-des-CE/nouveau-tutoriel',

	header_map:
	{
		'Titre': 'title',
		'Date': 'date'
	},

	row_link_base: '/gestion-des-CE/tutoriels/',
	searched_prop: 'title',

	field_hook:
	{
		'Date': function (value)
		{
			return window.moment(value).format('dddd DD MMMM');
		}
	}
};

var config = mergeDeep({ }, form);

mergeDeep(config, list);

export default config